if (!customElements.get('show-more-section')) {
  customElements.define(
    'show-more-section',
    class ShowMoreSection extends HTMLElement {
      constructor() {
        super();
        this.showMoreButton = this.querySelector('[data-show-hidden]');
        this.showMoreItems = this.querySelector('[data-hidden-blocks]');
        if (!this.showMoreButton && !this.showMoreItems) return;
        this.init();
      }

      init() {
        const showMoreText = this.showMoreButton.innerText;
        const showLessText = this.showMoreButton.dataset.showHidden;
        this.showMoreButton.addEventListener('click', () => {
          this.showMoreItems.classList.toggle('active');
          this.showMoreButton.innerText = this.showMoreItems.classList.contains('active') ? showLessText : showMoreText;
        });
      }
    }
  );
}
